//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';

export default {
    data: function data() {
        return {
            period: moment(),
            transaction_date: moment().format("MM/DD/YYYY"),
            amount: '',
            residents: [],
            transaction_file_bool: false,
            lines: [],
            paymentTypes: null,
            saving: false
        };
    },
    created: function created() {
        Event.$on('past-resident-ar-deposit', this.pastResidentARDeposit);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('past-resident-ar-deposit');
    },

    methods: {
        pastResidentARDeposit: function pastResidentARDeposit(item) {
            var _this = this;

            var $el = this;
            Object.assign(this.$data, this.$options.data());
            $el.$children[0].$data.showModal = true;

            axios.get('/api/paymentTypes').then(function (response) {
                return _this.paymentTypes = response.data;
            });

            var payLoad = [];
            payLoad.push(item);
            $el.residents = payLoad;
            $el.residents.map(function (item) {
                item.full_name = (item.is_applicant ? 'Applicant' : item.unit.name) + ': ' + item.person.full_name;
            });
            $el.lines.push({
                resident: null,
                balance: 0.00,
                reference: '',
                amount: 0.00,
                hasFile: false,
                payment_type: ''
            });
        },
        save: function save() {
            var $el = this;

            this.saving = true;

            var formData = new FormData(document.querySelector('form'));

            var deposit = {
                applicant: this.applicant,
                period: this.period,
                transaction_date: this.transaction_date,
                amount: this.amount,
                transaction_file_bool: this.transaction_file_bool,
                lines: this.lines,
                paymentTypes: this.paymentTypes
            };

            deposit['total'] = this.total;

            deposit['residents'] = '';

            // clean up before sending
            deposit.lines.map(function (line) {
                line['resident']['person'] = '';
                line['resident']['unit'] = '';
            });

            formData.append("deposit", JSON.stringify(deposit));

            axios.post('/prototype/accounting/accounts-receivable/deposits/store', formData).then(function () {
                Event.$emit('refresh-past-resident-ledger');
                Event.$emit('past-resident-list-updated');
                $el.$children[0].$data.showModal = false;
            });
        },
        updateBalance: function updateBalance(line, idx) {
            var _this2 = this;

            // '/prototype/accounting/accounts-receivable/resident/balance'
            var url = '/prototype/accounting/accounts-receivable/' + (line.resident && line.resident.is_applicant ? 'applicant' : 'resident') + '/balance';

            if (line.resident) {
                axios.post(url, {
                    id: line.resident.id
                }).then(function (response) {
                    return _this2.lines[idx].balance = response.data;
                });
            } else {

                this.lines[idx].balance = 0.00;
            }
        },
        addLine: function addLine() {
            this.lines.push({
                resident: null,
                balance: 0.00,
                reference: '',
                amount: 0.00,
                hasFile: false,
                payment_type: this.paymentTypes[0]
            });
        },
        deleteLine: function deleteLine(idx) {
            this.lines.splice(idx, 1);
        }
    },

    computed: {
        total: function total() {
            return Number.parseFloat(this.lines.reduce(function (prev, cur) {
                return prev + cur.amount;
            }, 0)).toFixed(2);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/past-residents/PastResidentAddDeposit.vue
// module id = BRFk
// module chunks = 0 1